import axios from "axios";

import * as Sentry from "@sentry/react";

const baseURL = process.env.REACT_APP_ADMIN_API_BASE_URL;

const instance = axios.create({
  baseURL: baseURL,
});

instance.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("token");
    request.headers!["Authorization"] = `Bearer ${token}`;
    request.headers!["Content-Type"] = "application/json";

    return request;
  },
  (error) => {
    Sentry.captureException(error);
    console.info("error captured", error);
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    Sentry.captureException(error);
    console.info("error captured", error);
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userRole");
      localStorage.removeItem("currLocation");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export { instance };

export const callCenterApi = {
  getOrders() {
    return instance.get(`/v3/callcenter/orders`);
  },
  getLocations() {
    return instance.get(`/v3/callcenter/locations`);
  },
  postOrders(body: { restaurant_id: string; order_id: string }) {
    return instance.post(`/v3/callcenter/orders`, body);
  },
  putOrders(orderId: string, body: { status: string }) {
    return instance.put(`/v3/callcenter/orders/${orderId}`, body);
  },
};

export const selectAllApi = {
  getLocations(restaurantGroupId: string) {
    return instance.get(`/v3/locations/group/${restaurantGroupId}`);
  },

  getOldProductVersion(productId: string, newProductVersion: any) {
    return instance.post(
      `/v3/locations/product/${productId}/compare`,
      newProductVersion
    );
  },
  updateSAProduct(productId: string, body: any) {
    return instance.patch(`/v3/locations/product/${productId}`, body);
  },
};
